import { IUpdateChecklistServicoLiberacaoUseCase } from "../../../presentation/useCases/update/update_checklist_servico_liberacao_use_case";
import { IObrasRepository } from "../../repositories/obras_repository";

/**
 * UpdateChecklistServicoLiberacaoUseCase
 */

export class UpdateChecklistServicoLiberacaoUseCase implements IUpdateChecklistServicoLiberacaoUseCase {
  constructor(private readonly repository: IObrasRepository) { }

  async execute(
    idChecklistServicoLiberacao: number,
    ordem: string,
    descricao: string,
  ): Promise<void> {
    await this.repository.updateChecklistServicoLiberacao(
      idChecklistServicoLiberacao,
      ordem,
      descricao,
    );
  }
}
